// src/data/mockData.js
// Mock data for unauthenticated users
// This data is displayed in the calendar when no user is signed in

const mockData = {
  "balances": {
    "-OKIMveyt5KfKjeMGcJ2": {
      "amount": 300000,
      "createdAt": "2025-03-01T20:22:17.532Z",
      "date": "2025-03-01",
      "isPaid": false,
      "lastUpdated": "2025-05-01T23:30:35.678Z",
      "title": "Checking",
      "type": "balance"
    },
    
  },
  "budgets": {
    "-OJACLkpA2FiJSyu0vjP": {
      "amount": 0,
      "color": "#FF7283",
      "createdAt": "2025-03-01T20:13:58.582Z",
      "date": "2025-03-01",
      "emoji": "🏠",
      "isPaid": false,
      "title": "Housing",
      "type": "budget"
    },
    "-OJADQPMJvMQl5KBoaCc": {
      "amount": 0,
      "color": "#F5BF26",
      "createdAt": "2025-03-01T20:13:58.582Z",
      "date": "2025-03-01",
      "emoji": "🍽️",
      "isPaid": false,
      "title": "Food",
      "type": "budget"
    },
    "-OJADR14tUaKW9n81Jnq": {
      "amount": 0,
      "color": "#039BE5",
      "createdAt": "2025-03-01T20:13:58.582Z",
      "date": "2025-03-01",
      "emoji": "🚗",
      "isPaid": false,
      "title": "Transportation",
      "type": "budget"
    },
    "-OJADRmU8QSsNZoG9Cv5": {
      "amount": 0,
      "color": "#3F51B5",
      "createdAt": "2025-03-01T20:13:58.582Z",
      "date": "2025-03-01",
      "emoji": "💡",
      "isPaid": false,
      "title": "Utilities",
      "type": "budget"
    },
    "-OJADWsblghS5A1r2_KM": {
      "amount": 0,
      "color": "#8E24AA",
      "createdAt": "2025-03-01T20:13:58.582Z",
      "date": "2025-03-01",
      "emoji": "🎭",
      "isPaid": false,
      "title": "Entertainment",
      "type": "budget"
    },
    "-OJADftlmo7iSMzW6xiA": {
      "amount": 0,
      "color": "#5FD8D5",
      "createdAt": "2025-03-01T20:13:58.582Z",
      "date": "2025-03-01",
      "emoji": "📚",
      "isPaid": false,
      "title": "Education",
      "type": "budget"
    },
    "-OJADhEHkUPyF8djIZqY": {
      "amount": 0,
      "color": "#795548",
      "createdAt": "2025-03-01T20:13:58.582Z",
      "date": "2025-03-01",
      "emoji": "🏥",
      "isPaid": false,
      "title": "Healthcare",
      "type": "budget"
    },
    "-OJADiAfbiOaREufe-Ng": {
      "amount": 0,
      "color": "#E67C73",
      "createdAt": "2025-03-01T20:13:58.582Z",
      "date": "2025-03-01",
      "emoji": "👤",
      "isPaid": false,
      "title": "Personal",
      "type": "budget"
    }
  },
  "expenses": {
    "-OKILxKMKz0vySmKo3Q-": {
      "amount": 5000,
      "budgetCategoryId": "-OJADQPMJvMQl5KBoaCc",
      "createdAt": "2025-03-01T20:18:02.547Z",
      "date": "2025-03-06",
      "emoji": "🛒",
      "isPaid": false,
      "notificationPreference": [
        "off"
      ],
      "recurrenceFrequency": 2,
      "recurrencePeriod": "weeks",
      "reminder": {
        "days": 1,
        "enabled": true,
        "time": "09:00"
      },
      "title": "Groceries",
      "type": "expense"
    },
    "-OKINVFucC9eLjUXSQDM": {
      "amount": 1500,
      "budgetCategoryId": "-OJADWsblghS5A1r2_KM",
      "createdAt": "2025-03-01T20:24:47.262Z",
      "date": "2025-03-28",
      "emoji": "🎬",
      "isPaid": false,
      "notificationPreference": [
        "off"
      ],
      "recurrenceFrequency": 1,
      "recurrencePeriod": "months",
      "reminder": {
        "days": 1,
        "enabled": true,
        "time": "09:00"
      },
      "title": "Netflix",
      "type": "expense"
    },
    "-OKIOAUYvxHTeRws81pE": {
      "amount": 5000,
      "budgetCategoryId": "-OJADRmU8QSsNZoG9Cv5",
      "createdAt": "2025-03-01T20:27:44.323Z",
      "date": "2025-03-05",
      "dueDate": "2025-03-05",
      "emoji": "💡",
      "id": "-OKIOAUYvxHTeRws81pE",
      "isPaid": false,
      "isPastDue": false,
      "isRecurring": true,
      "notificationPreference": [
        "off"
      ],
      "occurrenceDate": "2025-03-05",
      "originalId": "-OKIOAUYvxHTeRws81pE",
      "recurrenceFrequency": 1,
      "recurrencePeriod": "months",
      "reminder": {
        "days": 1,
        "enabled": true,
        "time": "09:00"
      },
      "title": "Electricity",
      "type": "expense"
    },
    "-OKIUcl54fMtA_t7cv-T": {
      "amount": 50000,
      "budgetCategoryId": "-OJADR14tUaKW9n81Jnq",
      "createdAt": "2025-03-01T20:55:57.047Z",
      "date": "2025-03-30",
      "emoji": "📜",
      "isPaid": false,
      "notificationPreference": [
        "1",
        "7"
      ],
      "recurrenceFrequency": 1,
      "recurrencePeriod": "months",
      "reminder": {
        "days": 1,
        "enabled": true,
        "time": "09:00"
      },
      "title": "Car payment",
      "type": "expense"
    },
    "-OKJ2z-mo42IBZ3pORnq": {
      "amount": 180000,
      "budgetCategoryId": "-OJACLkpA2FiJSyu0vjP",
      "createdAt": "2025-03-01T23:34:45.095Z",
      "date": "2025-03-02",
      "emoji": "🏠",
      "isPaid": false,
      "notificationPreference": [
        "off"
      ],
      "recurrenceFrequency": 1,
      "recurrencePeriod": "months",
      "reminder": {
        "days": 1,
        "enabled": true,
        "time": "09:00"
      },
      "title": "Rent",
      "type": "expense"
    },
    "-OKJ5VDOa7qQMWpJZxhE": {
      "amount": 3000,
      "budgetCategoryId": "-OJADhEHkUPyF8djIZqY",
      "createdAt": "2025-03-01T23:45:45.374Z",
      "date": "2025-03-11",
      "dueDate": "2025-03-11",
      "emoji": "🧘",
      "id": "-OKJ5VDOa7qQMWpJZxhE",
      "isPaid": false,
      "isPastDue": false,
      "notificationPreference": [
        "off"
      ],
      "recurrencePeriod": "none",
      "reminder": {
        "days": 1,
        "enabled": true,
        "time": "09:00"
      },
      "title": "Gym",
      "type": "expense"
    },
    "-OKRNt3153tpH69cq0wo": {
      "amount": 3000,
      "budgetCategoryId": "-OJADR14tUaKW9n81Jnq",
      "createdAt": "2025-03-03T14:23:03.338Z",
      "date": "2025-03-08T00:00:00.000-08:00",
      "emoji": "⛽",
      "isPaid": false,
      "notificationPreference": [
        "off"
      ],
      "recurrenceFrequency": 1,
      "recurrencePeriod": "weeks",
      "reminder": {
        "days": 1,
        "enabled": true,
        "time": "09:00"
      },
      "title": "Gas",
      "type": "expense",
      "updatedAt": "2025-03-03T14:23:55.598Z"
    }
  },
  "income": {
    "-OKILgL9rTQLKeNVkUf5": {
      "amount": 300000,
      "createdAt": "2025-03-01T20:16:53.118Z",
      "date": "2025-05-07",
      "dueDate": "2025-05-07",
      "emoji": "👨‍🍳",
      "id": "-OKILgL9rTQLKeNVkUf5",
      "isException": true,
      "isPaid": false,
      "isRecurring": true,
      "movedFrom": "2025-03-07",
      "occurrenceDate": "2025-03-06",
      "originalId": "-OKILgL9rTQLKeNVkUf5",
      "recurrenceFrequency": 2,
      "recurrencePeriod": "weeks",
      "title": "My Job",
      "type": "income",
      "updateType": "all"
    }
  },
  "settings": {
    "weatherWarnings": {
      "clearSkies": {
        "color": "#22C55E",
        "emoji": "☀️",
        "title": "Clear Skies"
      },
      "partlyCloudy": {
        "color": "#0EA5E9",
        "emoji": "⛅",
        "title": "Partly Cloudy"
      },
      "rainWarning": {
        "color": "#EA580C",
        "emoji": "🌧️",
        "recommendation": "Keep an eye on your spending in the coming days",
        "title": "Rain Expected"
      },
      "selectedScale": "moderate",
      "stormWarning": {
        "color": "#DC2626",
        "emoji": "⛈️",
        "recommendation": "Your balance is getting low. Consider adding income or reducing expenses",
        "title": "Storm Warning"
      },
      "thresholds": {
        "partlyCloudy": 500,
        "rainWarning": 200,
        "stormWarning": 100
      }
    }
  }
};

// Export the mock data that can be used when a user is not authenticated
export default mockData;